import { render, staticRenderFns } from "./ProductDetails.vue?vue&type=template&id=77c51ebd&scoped=true&lang=pug&"
import script from "./ProductDetails.vue?vue&type=script&lang=js&"
export * from "./ProductDetails.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetails.vue?vue&type=style&index=0&id=77c51ebd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c51ebd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77c51ebd')) {
      api.createRecord('77c51ebd', component.options)
    } else {
      api.reload('77c51ebd', component.options)
    }
    module.hot.accept("./ProductDetails.vue?vue&type=template&id=77c51ebd&scoped=true&lang=pug&", function () {
      api.rerender('77c51ebd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/product/bourdain/ProductDetails.vue"
export default component.exports